import { Button, ConfigProvider } from "antd";
import { useThemeStyles } from "../theme";
import styles from "./index.module.scss";
import { BtnSelfProp } from "./props";

export const ButtonSelf = (prop: BtnSelfProp) => {
  const { styles: stylesMyTheme } = useThemeStyles();

  return (
    <ConfigProvider
      theme={{
        components: {
          Button: {
            defaultBg: stylesMyTheme["myButtonAllowColor"],
            colorText: "rgb(255,255,255)",
          },
        },
      }}
    >
      <Button type="default" className={styles["button"]} {...prop}>
        {prop.children}
      </Button>
    </ConfigProvider>
  );
};
